define((require) => {
    "use strict";

    const ImprovedView  = require("editor/zbone/ImprovedView");
    const template      = require("ui/editor/ExperienceTemplateOptionsView.tpl");

    /**
     * @class ExperienceTemplateOptionsView
     */
    return ImprovedView.extend({

        className: "wrap",

        template,

        ui: {
            button: ".button"
        },

        triggers: {
            "click @ui.button": "clickTemplateSave"
        },

        initialize() {
            this.listenTo(this.options.experience, "sync:state", this.render);
        },

        modelEvents: {
            "change": "render"
        },

        onRender() {
            const {button} = this.ui;

            if (this.model.isNew()) {
                button.removeClass("btn-danger");
                button.addClass("btn-warning");
                button.text("Create template");
            } else {
                let text = "Update template";
                if (this._hasUnsavedChanges()) {
                    text += "*";
                }
                button.removeClass("btn-warning");
                button.addClass("btn-danger");
                button.text(text);
            }
        },

        _hasUnsavedChanges() {
            return this.model.get("content").version !== this.options.experience.get("version");
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/ExperienceTemplateOptionsView.js